export default {
	notification_health: 'Saúde das notificações',
	notification_health_summary: 'Resumo',
	notification_health_loading: 'A verificar a saúde das notificações...',
	notification_health_refresh: 'Atualizar',
	notification_health_fix: 'O que fazer',
	notification_health_unavailable: 'Não foi possível carregar a saúde das notificações',
	notification_health_healthy: 'Saudável',
	notification_health_blocked: 'Bloqueado',
	notification_health_degraded: 'Requer atenção',
	notification_health_no_app_user: 'Sem login na app',
	notification_health_unknown: 'Desconhecido',
	notification_health_app_version: 'Versão da app',
	notification_health_last_delivery: 'Última entrega',
	notification_health_time_just_now: 'agora mesmo',
	notification_health_time_minutes: 'há {count} minuto(s)',
	notification_health_time_hours: 'há {count} hora(s)',
	notification_health_time_days: 'há {count} dia(s)',
	notification_health_time_unknown: 'desconhecido',
	notification_health_summary_healthy: 'As notificações devem funcionar',
	notification_health_summary_no_app_user: 'O funcionário de limpeza não iniciou sessão na app móvel',
	notification_health_summary_blocked_no_token: 'Token push em falta — o funcionário deve abrir a app e iniciar sessão',
	notification_health_summary_blocked_off: 'As notificações estão desativadas na app',
	notification_health_check_portal_contact_label: 'Contacto do portal existe',
	notification_health_check_portal_active_label: 'Contacto ativo',
	notification_health_check_portal_rooms_label: 'Salas atribuídas',
	notification_health_check_portal_shifts_label: 'Turnos atribuídos',
	notification_health_check_app_user_label: 'Sessão iniciada na app móvel',
	notification_health_check_push_token_label: 'Token push registado',
	notification_health_check_notification_mode_label: 'Modo de notificação',
	notification_health_check_time_schedule_label: 'Dentro da janela de notificações',
	notification_health_check_ios_geo_filter_label: 'Filtro de localização iOS',
	notification_health_check_recent_push_attempt_label: 'Tentativa de push recente (48h)',
	notification_health_check_last_push_ignored_label: 'Último sinal não foi enviado',
	notification_health_check_recent_push_delivered_label: 'Push entregue recentemente (48h)',
	notification_health_detail_portal_contact_found: 'Encontrado no portal',
	notification_health_detail_portal_contact_missing: 'Registo de contacto não encontrado',
	notification_health_detail_portal_active_active: 'Ativo',
	notification_health_detail_portal_active_inactive: 'Inativo',
	notification_health_detail_portal_rooms_assigned: '{count} sala(s)',
	notification_health_detail_portal_rooms_none: 'Nenhuma sala atribuída',
	notification_health_detail_portal_shifts_assigned: '{count} turno(s)',
	notification_health_detail_portal_shifts_none: 'Nenhum turno atribuído',
	notification_health_detail_app_user_logged_in: 'Versão da app {version}, última sincronização {lastSync}',
	notification_health_detail_app_user_never: 'Nunca iniciou sessão',
	notification_health_detail_push_token_present: 'Token FCM presente',
	notification_health_detail_push_token_empty: 'Token vazio',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'A hora atual está dentro do horário',
	notification_health_detail_time_schedule_outside: 'A hora atual está fora do horário configurado',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Sem tentativas de push nas últimas 48 horas',
	notification_health_detail_last_push_ignored: 'O último pedido de push foi ignorado (servik não configurado para a área de trabalho)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Sem entregas bem-sucedidas nas últimas 48 horas',
	notification_health_fix_portal_contact: 'Criar este funcionário de limpeza no painel de Utilizadores',
	notification_health_fix_portal_active: 'Ativar o interruptor Ativo para este funcionário',
	notification_health_fix_portal_rooms: 'Atribuir pelo menos uma sala a este funcionário',
	notification_health_fix_portal_shifts: 'Atribuir pelo menos um turno',
	notification_health_fix_app_user: 'O funcionário deve instalar a app e iniciar sessão com este número de telefone',
	notification_health_fix_push_token: 'Peça ao funcionário para abrir a app, permitir notificações nas Definições iOS e iniciar sessão novamente',
	notification_health_fix_notification_mode: 'Alterar o modo de notificação de Desligado para Sempre na app',
	notification_health_fix_time_schedule: 'Aguardar até à janela agendada ou alterar o modo para Sempre',
	notification_health_fix_ios_geo_filter: 'O funcionário está fora da zona de notificação — peça-lhe para abrir a app no local',
	notification_health_fix_last_push_ignored: 'Verificar a configuração do servik da área de trabalho para a sala que acionou o sinal',
	notification_health_fix_recent_push_delivered_filters: 'Verificar filtros de notificação ou definições do dispositivo',
	notification_health_fix_recent_push_delivered_token: 'Registar primeiro o token push',
	notification_health_mode_on: 'Sempre',
	notification_health_mode_off: 'Desligado',
	notification_health_mode_time: 'Por horário',
	notification_health_mode_location: 'Por localização',
	notification_health_filter_on: 'Ligado',
	notification_health_filter_off: 'Desligado',
};
